export default __webpack_public_path__ + "static/10-ed9f60c728b32c6de550a682304a533e.webp";